import AbstractView from "../../../../../shared/src/ranj/equalture/view/AbstractView";

export default class BottomHudView extends AbstractView {

    constructor(target, languagePack) {
        super(target);
        this._languagePack = languagePack;

        this._handleDoneClick = this._handleDoneClick.bind(this);
        this._handleClearClick = this._handleClearClick.bind(this);
        this._handleNextClick = this._handleNextClick.bind(this);
        this._buttonSubmit = this.createButton(this._target.buttonSubmit, this._handleDoneClick, this.getText("hud.buttonSubmit"));
        this._buttonClear = this.createButton(this._target.buttonClear, this._handleClearClick);
        this._buttonClear.setCenteredLabel(this.getText("hud.buttonClear"));
        this._buttonNext = this.createButton(this._target.buttonNext, this._handleNextClick, this.getText("hud.buttonNext"));
        this.enableSubmit(false);
        this.enableClear(false);
        this.showSubmit(false, true);
        this.showClear(false, true);
        this.showNext(false, true);
        this._timer = this._target.Timer.TimerFill;
        this.setTimer(1);
        this.hideTimer();
    }

    showTimer() {
        createjs.Tween.get(this._timer)
            .to({ alpha: 1 }, 250, createjs.Ease.quadIn);

    }

    hideTimer() {
        createjs.Tween.removeTweens(this._timer);
        this._timer.alpha = 0;
    }

    /**
     * 
     * @param {number} p in range 0 .. 1
     */
    setTimer(p) {
        this._timer.alpha = 1;
        this._timer.gotoAndStop(Math.floor(p * (this._timer.totalFrames-1)));
    }

    _showButton(button, bool, instant = false, delay = 0) {
        const dur = instant ? 0 : 300;
        const ease = bool ? createjs.Ease.quadIn : createjs.Ease.quadOut
        const alpha = bool ? 1 : 0;
        if (instant) {
            button.target.alpha = alpha;
        } else {
            createjs.Tween.get(button.target)
                .wait(delay)
                .to({ alpha }, dur, ease);
        }
    }

    showSubmit(bool, instant = false, delay = 0) {
        this._showButton(this._buttonSubmit, bool, instant, delay);
    }

    enableSubmit(bool) {
        this._buttonSubmit.setEnabled(bool);
    }

    showClear(bool, instant = false, delay = 0) {
        this._showButton(this._buttonClear, bool, instant, delay);
    }

    enableClear(bool) {
        this._buttonClear.setEnabled(bool);
    }

    showNext(bool, instant = false, delay = 0) {
        this._showButton(this._buttonNext, bool, instant, delay);
    }

    enableNext(bool) {
        this._buttonNext.setEnabled(bool);
    }

    _handleDoneClick() {
        this.dispatchEvent(BottomHudView.SUBMIT);
    }

    _handleClearClick() {
        this.dispatchEvent(BottomHudView.CLEAR);
    }

    _handleNextClick() {
        this.dispatchEvent(BottomHudView.NEXT);
    }
}

BottomHudView.SUBMIT = "BottomHudView.SUBMIT";
BottomHudView.CLEAR = "BottomHudView.CLEAR";
BottomHudView.NEXT = "BottomHudView.NEXT";